define('presentation/analytics/facades/addScheduledReportModalFacade',[
        'externalDependencies/clientWebSocket'
], function (
        /** @type typeof import('externalDependencies/clientWebSocket') */
        ClientWebSocket
    ) {
        /** @typedef {import('common/promises/promiseFactory')} PromiseFactory   */

        /** @type {PromiseFactory} */
        let _promiseFactory = null;
        const _scheduledReportsSocket = ClientWebSocket.forApplication("scheduledReport");

        const _init = function (/** @type {PromiseFactory} */promiseFactory) {
            _promiseFactory = promiseFactory;
        };

        const _saveScheduledReport = (subject, message, format, graphDataPointsBy, frequency, sendToEmailAddresses, timeframe, involvingHostedNumberIds, involvingUserIds, involvingUserGroupIds) => {
            return _promiseFactory.defer((promise) => {
                const scheduledReport = {
                    subject: subject,
                    message: message,
                    deliveryFormat: parseInt(format),
                    graphDataPointsBy: parseInt(graphDataPointsBy),
                    deliveryFrequency: parseInt(frequency),
                    sendToEmailAddresses: sendToEmailAddresses,
                    timeframe: timeframe,
                    involvingHostedNumberIds: involvingHostedNumberIds,
                    involvingUserIds: involvingUserIds,
                    involvingUserGroupIds: involvingUserGroupIds,
                };
                _scheduledReportsSocket.send("addScheduledReport", scheduledReport, (response) => {
                    promise.resolve(response);
                });
            });
        };

        const _sendOneTimeReport = (subject, message, format, graphDataPointsBy, sendToEmailAddresses, timeframe, involvingHostedNumberIds, involvingUserIds, involvingUserGroupIds) => {
            return _promiseFactory.defer((promise) => {
                const scheduledReport = {
                    subject: subject,
                    message: message,
                    deliveryFormat: parseInt(format),
                    graphDataPointsBy: parseInt(graphDataPointsBy),
                    sendToEmailAddresses: sendToEmailAddresses,
                    timeframe: timeframe,
                    involvingHostedNumberIds: involvingHostedNumberIds,
                    involvingUserIds: involvingUserIds,
                    involvingUserGroupIds: involvingUserGroupIds,
                };
                _scheduledReportsSocket.send("sendOneTimeReport", scheduledReport, (response) => {
                    promise.resolve(response);
                });
            });
        };

        return function () {
            const self = this;

            self.init = _init;
            self.saveScheduledReport = _saveScheduledReport;
            self.sendOneTimeReport = _sendOneTimeReport;
        };
    }
);

